import Button from "@mostrans/web-components/components/base/Button";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import { Box, CardContent, Card, Typography, CardHeader } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useSetState } from "react-use";
import { useApolloClient } from "@apollo/client";
import { updatePasswordCandidate } from "../../graphql/mutations";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useLocation } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { globalModalOpenAtom } from "../../shared/globalStates";

const VerifyOTP = ({ data }) => {
  const client = useApolloClient();
  const [values, setValues] = useSetState({
    email: data.email,
    password: "",
    repassword: "",
  });
  const [isEmpty, setIsEmpty] = useState(null);
  const [errMsg1, setErrMsg1] = useState(null);
  const [errMsg2, setErrMsg2] = useState(null);
  const [success, setSuccess] = useState(false);
  const passwordVal = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/i;

  const handleSubmit = async (e) => {
    if (
      !values.password ||
      !values.repassword ||
      !values.password.match(passwordVal)
    ) {
      setIsEmpty(true);
    } else {
      if (values.password !== values.repassword) {
        setErrMsg1(
          "Password does not match! Please check your password again!"
        );
      } else if (values.password.length < 8) {
        setErrMsg1("Your password must be at least 8 characters");
      } else {
        const result = await updatePasswordCandidate(client, values);
        if (result.status !== "000") {
          setErrMsg2("Error, Try again later!");
        } else {
          setSuccess(true);
        }
      }
    }
  };
  const input = useRef();
  useEffect(() => {
    input.current.focus();
  }, []);

  return (
    <React.Fragment>
      {success ? (
        <Success setSuccess={setSuccess} />
      ) : (
        <Box display="flex" justifyContent="center" alignItems="center">
          <Card>
            <CardContent>
              <Typography variant="h5" component="h5" textAlign="center">
                Create New Password
              </Typography>
              <Box component="span" fontSize={14}>
                Enter your password correctly and create a password that is
                safe.
              </Box>
              <Box mt={2}>
                <FormGroup
                  errorMessage={
                    isEmpty && !values.password
                      ? "Password cannot be empty!"
                      : !values.password.match(passwordVal)
                      ? "Password must be 8-20 characters long and include at least 1 letter and 1 number"
                      : errMsg1
                  }
                  isError={Boolean(
                    (isEmpty && !values.password) ||
                      (values.password && !values.password.match(passwordVal))
                  )}
                  isRequired
                  showChildErrorSign
                  className="font-size-main"
                  label="Password"
                  style={{ marginBottom: "15px" }}>
                  <Input
                    type="password"
                    ref={input}
                    min="0"
                    max="9"
                    value={values.password}
                    onChange={(e) => setValues({ password: e.target.value })}
                    minLength={7}
                    placeholder="Enter Password"
                  />
                </FormGroup>
                <FormGroup
                  errorMessage={
                    isEmpty && !values.password
                      ? "Confirm password cannot be empty!"
                      : values.repassword !== values.password
                      ? "Password does not match! Please check your password again!"
                      : errMsg1
                  }
                  isError={Boolean(
                    (isEmpty && !values.repassword) ||
                      (values.repassword &&
                        values.repassword !== values.password)
                  )}
                  isRequired
                  showChildErrorSign
                  className="font-size-main"
                  label="Confirm password"
                  style={{ marginBottom: "15px" }}>
                  <Input
                    type="password"
                    min="0"
                    max="9"
                    value={values.repassword}
                    onChange={(e) => setValues({ repassword: e.target.value })}
                    minLength={7}
                    placeholder="Confirm password"
                  />
                </FormGroup>
                <div className="form-group d-flex justify-content-center w-100">
                  <p
                    className="text-danger"
                    style={{ fontSize: "1rem", fontWeight: "bold" }}>
                    {errMsg2}
                  </p>
                </div>
              </Box>
              <Box textAlign="center" mt={3}>
                <Button
                  type="submit"
                  onClick={(e) => handleSubmit(e)}
                  variant="contained"
                  color="primary">
                  Create Password
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      )}
    </React.Fragment>
  );
};

export default VerifyOTP;

const Success = () => {
  const history = useHistory();
  const location = useLocation();
  const setopen = useSetRecoilState(globalModalOpenAtom);
  const loc = location.pathname === "/login";
  const handleClose = () => {
    history.push("/login");
    setopen(false);
  };
  return (
    <React.Fragment>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Card>
          <CardHeader
            className="text-primary-h3 text-textSecondary"
            avatar={
              <svg
                viewBox="0 0 225 225"
                style={{ fill: "#fff", margin: "-2.5em auto -2.5em 20px" }}
                x="0px"
                y="0px"
                xmlSpace="preserve">
                <path
                  d="M131.583,92.152l-0.026-0.041c-0.713-1.118-2.197-1.447-3.316-0.734l-31.782,20.257l-4.74-12.65
    c-0.483-1.29-1.882-1.958-3.124-1.493l-0.045,0.017c-1.242,0.465-1.857,1.888-1.374,3.178l5.763,15.382
    c0.131,0.351,0.334,0.65,0.579,0.898c0.028,0.029,0.06,0.052,0.089,0.08c0.08,0.073,0.159,0.147,0.246,0.209
    c0.071,0.051,0.147,0.091,0.222,0.133c0.058,0.033,0.115,0.069,0.175,0.097c0.081,0.037,0.165,0.063,0.249,0.091
    c0.065,0.022,0.128,0.047,0.195,0.063c0.079,0.019,0.159,0.026,0.239,0.037c0.074,0.01,0.147,0.024,0.221,0.027
    c0.097,0.004,0.194-0.006,0.292-0.014c0.055-0.005,0.109-0.003,0.163-0.012c0.323-0.048,0.641-0.16,0.933-0.346l34.305-21.865
    C131.967,94.755,132.296,93.271,131.583,92.152z"
                />
                <circle
                  fill="none"
                  stroke="#fff"
                  strokeWidth="5"
                  strokeMiterlimit="10"
                  cx="109.486"
                  cy="104.353"
                  r="32.53"
                />
              </svg>
            }
            titleTypographyProps={{
              variant: "h4",
              color: "#fff",
              fontWeight: "500",
            }}
            title="SUCCESS"
            sx={{
              color: "#fff !important",
              fontWeight: "500",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              display: "block",
              bgcolor: "#8BC34A",
              margin: "auto",
            }}
          />
          <CardContent sx={{ textAlign: "center" }}>
            {loc ? (
              <Typography>
                Congratulations, your password has been changed successfully
              </Typography>
            ) : (
              <Typography>
                Congratulations, your account has been created successfully
              </Typography>
            )}

            <Button
              onClick={() => (loc ? setopen(false) : handleClose())}
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}>
              Done
            </Button>
          </CardContent>
        </Card>
      </Box>
    </React.Fragment>
  );
};
